import { render, staticRenderFns } from "./mobile_virtual.vue?vue&type=template&id=c5de1ec0&scoped=true"
import script from "./mobile_virtual.vue?vue&type=script&lang=js"
export * from "./mobile_virtual.vue?vue&type=script&lang=js"
import style0 from "./mobile_virtual.vue?vue&type=style&index=0&id=c5de1ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5de1ec0",
  null
  
)

export default component.exports